import { NgModule } from '@angular/core';
import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './Home/component/Home';
import { AuthGuard } from './Shared/service/AuthGuard';
import { UserProfileComponent } from './Home/component/UserProfile';
import { FAQComponent } from './Home/component/faq';

export const router: Routes = [ 
  { path: '', redirectTo: 'Home', canActivate: [AuthGuard], pathMatch: 'full' },
  {
    path: 'Home', component: HomeComponent
  },
  {
    path: 'profile',canActivate: [AuthGuard], component: UserProfileComponent
  },
  {
    path: 'faq', canActivate: [AuthGuard], component: FAQComponent
  },
  {
    path: 'Reports', canActivate: [AuthGuard], loadChildren: './Reports/Reports.module#ReportsModule'
  },  
  {
    path: '**', redirectTo: 'Reports', canActivate: [AuthGuard], pathMatch: 'full'
  }
];

export const appRouter: ModuleWithProviders = RouterModule.forRoot(router);


// WEBPACK FOOTER //
// C:/TeamCity/buildAgent/work/4b34a5ca2bd08993/UI/rp/src/app/app.router.ts